import api from "../api"


export async function connectStripe() {
  if (this.getState().connectingStripe) return

  this.setState({
    connectingStripe: true,
    connectStripeError: undefined,
  })

  try {
    const response = await api.connectStripeAccount()

    if (response.accountLink) {
      // Redirect to Stripe onboarding
      window.location.href = response.accountLink
    } else if (response.redirectUrl) {
      // Redirect to appropriate page based on status
      window.location.href = response.redirectUrl
    } else {
      throw new Error('No valid redirect URL received from server')
    }
  } catch (connectStripeError) {
    this.setState({ connectStripeError })
  } finally {
    this.setState({ connectingStripe: undefined })
  }
}

export async function refreshStatus() {
  if (this.getState().refreshingSellerStatus) return

  this.setState({
    refreshingSellerStatus: true,
    sellerStatusError: undefined,
  })

  try {
    const sellerStatus = await api.getSellerStatus()
    console.log('Seller status refreshed:', sellerStatus)
    this.setState({ sellerStatus })
  } catch (sellerStatusError) {
    this.setState({ sellerStatusError })
  } finally {
    this.setState({ refreshingSellerStatus: undefined })
  }
}

export async function getStatus() {
  if (this.getState().gettingSellerStatus) return

  this.setState({
    gettingSellerStatus: true,
    sellerStatusError: undefined,
  })

  try {
    const sellerStatus = await api.getSellerStatus()
    console.log('Seller status retrieved from seller.js:', sellerStatus)
    this.setState({ sellerStatus })
  } catch (sellerStatusError) {
    this.setState({ sellerStatusError })
  } finally {
    this.setState({ gettingSellerStatus: undefined })
  }
}
